import cssIcon from 'tfs.css-icons'

export default {
  icon: {
    position: 'relative',
    display: 'inline-block',
    cursor: prop => prop.onClick && 'pointer',

    '&::before': {
      content: props => cssIcon(props.name),
      fontFamily: 'transavicon',
      fontWeight: 'normal',
      verticalAlign: 'middle',
      lineHeight: 1,
      transformOrigin: 'left center',
    },
  },
}
